'use client';

import { useAuthStore } from '@/stores/useAuthStore';
import { useModalSlideStore } from '@/stores/useModalSlideStore';
import SignatureBadge from '@/components/features/achievement/SignatureBadge';
import SignatureMedal from '@/components/features/achievement/SignatureMedal';
import DashboardAchievementBadge from '@/components/features/dashboard/modal/DashboardAchievementBadge';
import DashboardAchievementMedal from '@/components/features/dashboard/modal/DashboardAchievementMedal';

export default function DashboardAchievementDataUnit() {
    const userScore = useAuthStore((s) => s.userScore);
    const userMedal = useAuthStore((s) => s.userMedal);
    const userBadges = useAuthStore((s) => s.userBadges);
    const openModalSlide = useModalSlideStore((state) => state.openModalSlide);

    return (
        <div className="contents">
            <div className="flex flex-col w-full rounded-2xl bg-color-white-base px-4 py-3">
                <AchievementCardHeader title="メダル" score={userScore?.totalMedalScore ?? 0} />
                <div
                    className="flex justify-center items-center w-full flex-grow cursor-pointer pt-2"
                    onClick={() =>
                        openModalSlide({
                            id: 'dashboard-achievement-medal',
                            component: <DashboardAchievementMedal />,
                            size: { pcWidth: 'min(900px, 95%)', mbWidth: '95%', height: '100%' },
                            direction: 'right',
                        })
                    }
                >
                    <SignatureMedal
                        medal={
                            userMedal
                                ? {
                                      achievement_score: userMedal.achievementScore ?? 0,
                                      medal_name: userMedal.medalName ?? '',
                                      medal_resource_url: userMedal.userSignatureMedalUrl ?? '',
                                  }
                                : null
                        }
                    />
                </div>
            </div>

            <div className="flex flex-col w-full rounded-2xl bg-color-white-base px-4 py-3 lg:col-span-2 xl:col-span-1">
                <AchievementCardHeader title="バッジ" score={userScore?.totalBadgeScore ?? 0} />
                <div
                    className="flex justify-center items-center w-full flex-grow cursor-pointer pt-2"
                    onClick={() =>
                        openModalSlide({
                            id: 'dashboard-achievement-badge',
                            component: <DashboardAchievementBadge />,
                            size: { pcWidth: 'min(900px, 95%)', mbWidth: '95%', height: '100%' },
                            direction: 'right',
                        })
                    }
                >
                    <SignatureBadge
                        badges={
                            userBadges && userBadges.length > 0
                                ? userBadges.map((badge) => ({
                                      badge_cd: badge.badgeCd ?? '',
                                      achievement_score: badge.achievementScore ?? 0,
                                      award_date_time: badge.awardDateTime ?? '',
                                  }))
                                : null
                        }
                    />
                </div>
            </div>
        </div>
    );
}

function AchievementCardHeader({ title, score }: { title: string; score: number }) {
    return (
        <div className="flex items-baseline w-full">
            <span className="font-corp font-bold text-xs text-color-base">{title}</span>
            <span className="font-corp text-xs text-color-co-gray-dark ml-auto">獲得スコア</span>
            <span className="font-cantarell font-bold text-base text-color-c-orange pl-2">{score}</span>
        </div>
    );
}
